<template>
  <span class="svg-ico-smile">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.86933 9.84255C8.41746 9.84255 8.05115 10.2089 8.05115 10.6607C8.05115 11.1126 8.41746 11.4789 8.86933 11.4789H8.8814C9.33327 11.4789 9.69958 11.1126 9.69958 10.6607C9.69958 10.2089 9.33327 9.84255 8.8814 9.84255H8.86933Z" :fill="color"/>
      <path d="M14.4147 10.6607C14.4147 10.2089 14.781 9.84255 15.2329 9.84255H15.245C15.6968 9.84255 16.0632 10.2089 16.0632 10.6607C16.0632 11.1126 15.6968 11.4789 15.245 11.4789H15.2329C14.781 11.4789 14.4147 11.1126 14.4147 10.6607Z" :fill="color"/>
      <path d="M9.98363 15.3828C9.66715 15.0602 9.14913 15.0553 8.8266 15.3718C8.50407 15.6883 8.49916 16.2063 8.81564 16.5289C10.5919 18.3391 13.5104 18.3391 15.2867 16.5289C15.6031 16.2063 15.5982 15.6883 15.2757 15.3718C14.9532 15.0553 14.4352 15.0602 14.1187 15.3828C12.9839 16.5393 11.1184 16.5393 9.98363 15.3828Z" :fill="color"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M22.4148 12.7788C22.4148 4.80987 13.777 -0.166335 6.86977 3.81565C3.66335 5.66407 1.6875 9.08068 1.6875 12.7788C1.6875 20.7477 10.3252 25.7239 17.2325 21.7419C20.4389 19.8934 22.4148 16.4768 22.4148 12.7788ZM7.68704 5.23331C13.5071 1.87811 20.7784 6.07329 20.7784 12.7788C20.7784 15.891 19.1155 18.7675 16.4152 20.3242C10.5952 23.6794 3.32386 19.4842 3.32386 12.7788C3.32386 9.66647 4.98673 6.78997 7.68704 5.23331Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
